/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../';
// prettier-ignore
const FacebookIcon = createIcon({
    displayName: 'FacebookIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("circle", {
            cx: "12",
            cy: "12",
            fill: "#fff",
            r: "8"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "m20 12c0-4.41824-3.5818-8-8-8-4.41824 0-8 3.58176-8 8 0 3.7517 2.58304 6.8998 6.0675 7.7645v-5.3197h-1.64958v-2.4448h1.64958v-1.0534c0-2.72292 1.2323-3.985 3.9056-3.985.5069 0 1.3815.09952 1.7392.19872v2.216c-.1888-.01984-.5168-.02976-.9241-.02976-1.3117 0-1.8186.49696-1.8186 1.78884v.8646h2.6131l-.4489 2.4448h-2.1642v5.4966c3.9613-.4784 7.0307-3.8512 7.0307-7.9414z",
            fill: "#0866ff"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("circle", {
            cx: "12",
            cy: "12",
            fill: "#fff",
            r: "11"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "m23 12c0-6.07508-4.9249-11-11-11-6.07508 0-11 4.92492-11 11 0 5.1586 3.55168 9.4873 8.34284 10.6762v-7.3146h-2.2682v-3.3616h2.2682v-1.4485c0-3.74394 1.69446-5.4793 5.37016-5.4793.697 0 1.8995.13684 2.3914.27324v3.047c-.2596-.02728-.7106-.04092-1.2707-.04092-1.8035 0-2.5005.68332-2.5005 2.45958v1.1889h3.593l-.6173 3.3616h-2.9757v7.5579c5.4468-.6578 9.6672-5.2954 9.6672-10.9195z",
            fill: "#0866ff"
        })
    ]
});
FacebookIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'FacebookIcon'
};
export { FacebookIcon };

//# sourceMappingURL=facebook.js.map